export const SYNC_JOBS = "SYNC_JOBS"

export const SYNC_JOBS_FETCH_LIST = "SYNC_JOBS_FETCH_LIST"
export const SYNC_JOBS_ITEMS_FETCH_LIST = "SYNC_JOBS_ITEMS_FETCH_LIST"
